// extracted by mini-css-extract-plugin
export var error = "InlineMessage-module--error--466fd";
export var info = "InlineMessage-module--info--ad516";
export var inlineMessage = "InlineMessage-module--inlineMessage--01d04";
export var inlineMessageIcon = "InlineMessage-module--inlineMessageIcon--b6989";
export var inlineMessageText = "InlineMessage-module--inlineMessageText--293c7";
export var lmsScrollbar = "InlineMessage-module--lms-scrollbar--122ff";
export var regularLarge = "InlineMessage-module--regular-large--4c22d";
export var regularMedium = "InlineMessage-module--regular-medium--88b91";
export var regularSmall = "InlineMessage-module--regular-small--b9bc0";
export var regularTiny = "InlineMessage-module--regular-tiny--e196e";
export var solidLarge = "InlineMessage-module--solid-large--6d7ad";
export var solidMedium = "InlineMessage-module--solid-medium--83981";
export var solidSmall = "InlineMessage-module--solid-small--88453";
export var solidTiny = "InlineMessage-module--solid-tiny--673d8";
export var warning = "InlineMessage-module--warning--22330";